if (!customElements.get('gallery-lightbox')) {
  customElements.define(
    'gallery-lightbox',
    class GalleryLightbox extends ModalDialog {
      constructor() {
        super();
        this.slides = Array.from(this.querySelectorAll('.gallery-lightbox__slide'));
        this.counter = this.querySelector('.gallery-lightbox__current');
        this.currentIndex = 0;

        this.querySelector('.gallery-lightbox__prev')?.addEventListener('click', () => this.showRelative(-1));
        this.querySelector('.gallery-lightbox__next')?.addEventListener('click', () => this.showRelative(1));

        this.addEventListener('keyup', (event) => {
          if (event.code === 'ArrowLeft') this.showRelative(-1);
          if (event.code === 'ArrowRight') this.showRelative(1);
        });
      }

      show(opener) {
        super.show(opener);
        this.showSlide(Number(opener.dataset.index || 0));
      }

      showRelative(delta) {
        if (!this.slides.length) return;
        const total = this.slides.length;
        this.showSlide((this.currentIndex + delta + total) % total);
      }

      showSlide(index) {
        this.currentIndex = index;
        this.slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('active', slideIndex === index);
        });
        if (this.counter) this.counter.textContent = index + 1;
      }
    }
  );
}
